var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCentroZapopan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 102,
    viewBox: "0 0 119 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0232 97.3352C60.2969 97.3352 61.3294 96.3069 61.3294 95.0383C61.3294 93.7698 60.2969 92.7415 59.0232 92.7415C57.7495 92.7415 56.7169 93.7698 56.7169 95.0383C56.7169 96.3069 57.7495 97.3352 59.0232 97.3352Z",
    fill: "#95C11F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8538 83.3963C22.2939 83.3963 20.9888 82.8928 19.94 81.886C18.8898 80.8693 18.3661 79.5612 18.3661 77.9588C18.3661 76.3564 18.901 75.0246 19.9694 73.9884C21.0476 72.9439 22.3527 72.4209 23.8832 72.4209C24.827 72.4209 25.7036 72.6147 26.5115 73.0038C27.3209 73.3915 27.9706 73.9173 28.4607 74.5797L26.9008 76.1612C26.0914 75.1933 25.1294 74.708 24.012 74.708C23.1256 74.708 22.3751 75.0148 21.759 75.6284C21.1428 76.2421 20.8348 77.0147 20.8348 77.9449C20.8348 78.875 21.1386 79.6128 21.745 80.218C22.3513 80.8219 23.1018 81.1245 23.998 81.1245C25.1532 81.1245 26.1404 80.635 26.9582 79.6574L28.5615 81.1538C28.0602 81.8344 27.3923 82.3782 26.5535 82.7869C25.7162 83.1941 24.8158 83.3977 23.8524 83.3977L23.8538 83.3963Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5169 83.2387H34.0786V72.6091H41.5309V74.8237H36.4759V76.7943H41.1556V78.9949H36.4759V81.0227H41.5169V83.2373V83.2387Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5157 78.8219V72.6077H56.8556V83.2372H55.1374L49.9242 77.0801V83.2372H47.5703V72.6077H49.1876L54.5171 78.8219H54.5157Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3469 83.2387V74.8962H62.3279V72.6091H70.7478V74.8962H67.7442V83.2387H65.3469Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6427 83.2387H81.8702L79.7753 79.5277H78.6061V83.2387H76.2228V72.6091H80.4685C81.6909 72.6091 82.6249 72.9396 83.2704 73.6021C83.916 74.245 84.238 75.0594 84.238 76.0468C84.238 76.7566 84.063 77.3898 83.7115 77.9448C83.3601 78.5012 82.8476 78.9182 82.174 79.1958L84.6441 83.2373L84.6427 83.2387ZM80.4545 74.7958H78.6061V77.4288H80.2962C80.7779 77.4288 81.1462 77.3047 81.4011 77.0551C81.6559 76.8054 81.7833 76.4847 81.7833 76.0914C81.7833 75.6981 81.6657 75.4081 81.4291 75.164C81.1938 74.92 80.8676 74.7972 80.4545 74.7972V74.7958Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5829 77.9449C89.5829 76.4011 90.1179 75.0972 91.1863 74.0331C92.2645 72.9593 93.5891 72.4224 95.1575 72.4224C96.7258 72.4224 98.0462 72.9593 99.1147 74.0331C100.193 75.0972 100.732 76.3969 100.732 77.931C100.732 79.465 100.197 80.7648 99.1287 81.8288C98.0504 82.8832 96.7216 83.4103 95.1421 83.4103C93.5625 83.4103 92.2295 82.8832 91.1709 81.8288C90.1123 80.7745 89.5829 79.4804 89.5829 77.9449ZM95.1575 81.066C96.034 81.066 96.7706 80.769 97.3671 80.1749C97.9636 79.5613 98.2577 78.8137 98.2479 77.931C98.2283 77.0106 97.9244 76.2575 97.3377 75.6731C96.7412 75.0693 96.013 74.7667 95.1561 74.7667C94.2991 74.7667 93.5485 75.0693 92.9604 75.6731C92.3639 76.2868 92.0642 77.0398 92.0642 77.931C92.0642 78.8221 92.3625 79.5613 92.9604 80.1749C93.5569 80.769 94.2893 81.066 95.1561 81.066H95.1575Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6421 101.783H0V99.6014L6.38948 91.2018H0.253451V88.4614H10.4433V90.7499L4.19944 99.0408H10.6421V101.781V101.783Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1384 101.783H26.0256L25.1392 99.0965H20.6513L19.7285 101.783H16.6157L21.6287 88.4614H24.2346L29.1398 101.783H29.1384ZM24.3425 96.4831L22.9128 92.2645L21.4649 96.4831H24.3425Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8724 88.4626H40.9946C42.6231 88.4626 43.8358 88.895 44.6325 89.761C45.4405 90.6145 45.8452 91.6841 45.8452 92.9699C45.8452 94.2558 45.4293 95.2947 44.5961 96.1245C43.763 96.9543 42.4901 97.3685 40.7776 97.3685H38.8592V101.785H35.8724V88.464V88.4626ZM38.8592 94.6811H40.8868C41.4777 94.6811 41.9426 94.5165 42.2801 94.1846C42.6175 93.8541 42.787 93.4371 42.787 92.9323C42.787 92.4275 42.6245 92.0286 42.2983 91.6981C41.972 91.3676 41.5435 91.203 41.0128 91.203H38.8592V94.6825V94.6811Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.089 95.1498C52.089 93.2155 52.7583 91.581 54.0984 90.2464C55.4497 88.9006 57.109 88.2271 59.0764 88.2271C61.0438 88.2271 62.6961 88.9006 64.0348 90.2464C65.386 91.581 66.0624 93.2085 66.0624 95.1316C66.0624 97.0548 65.3931 98.6823 64.053 100.017C62.7017 101.339 61.0368 102 59.0582 102C57.0796 102 55.4077 101.339 54.0816 100.017C52.7541 98.6948 52.0904 97.0729 52.0904 95.1498H52.089ZM59.075 99.0616C60.1728 99.0616 61.0956 98.6892 61.8447 97.9445C62.5925 97.1761 62.9608 96.2389 62.9482 95.133C62.9244 93.9797 62.5435 93.037 61.8083 92.3034C61.0606 91.5462 60.149 91.1668 59.075 91.1668C58.001 91.1668 57.06 91.5462 56.3234 92.3034C55.5757 93.0718 55.2018 94.016 55.2018 95.133C55.2018 96.2501 55.5757 97.1761 56.3234 97.9445C57.0712 98.6892 57.9884 99.0616 59.075 99.0616Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3369 88.4626H78.4591C80.089 88.4626 81.3002 88.895 82.097 89.761C82.905 90.6145 83.3097 91.6841 83.3097 92.9699C83.3097 94.2558 82.8938 95.2947 82.0606 96.1245C81.2274 96.9543 79.9546 97.3685 78.242 97.3685H76.3237V101.785H73.3369V88.464V88.4626ZM76.3237 94.6811H78.3513C78.9422 94.6811 79.4071 94.5165 79.7445 94.1846C80.082 93.8541 80.2514 93.4371 80.2514 92.9323C80.2514 92.4275 80.089 92.0286 79.7627 91.6981C79.4365 91.3676 79.008 91.203 78.4773 91.203H76.3237V94.6825V94.6811Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63 101.783H97.5169L96.6291 99.0965H92.1412L91.2184 101.783H88.1056L93.1186 88.4614H95.7245L100.63 101.783ZM95.8337 96.4831L94.404 92.2645L92.9562 96.4831H95.8337Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.068 96.2488V88.4614H119V101.783H116.846L110.313 94.0677V101.783H107.362V88.4614H109.39L116.068 96.2488Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.692 24.786C58.9266 26.3242 62.9174 25.7608 65.5961 23.093L81.1855 7.56704C79.6606 6.28681 78.0488 5.16138 76.3699 4.19214L67.2961 13.2291L55.692 24.786Z",
    fill: "url(#paint0_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5961 6.75119L70.7604 1.60796C68.6137 0.849303 66.4041 0.313782 64.1706 0L55.692 8.44422C58.9266 9.98244 62.9174 9.41903 65.5961 6.75119Z",
    fill: "url(#paint1_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.999 29.5708C66.4545 32.7923 67.0202 36.7669 69.699 39.4347L85.2883 54.9606C86.5737 53.4419 87.7038 51.8368 88.6769 50.1646L79.6031 41.1277L67.999 29.5708Z",
    fill: "url(#paint2_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1075 39.4347L91.2717 44.5779C92.0334 42.44 92.5712 40.2394 92.8862 38.015L84.4075 29.5708C82.863 32.7923 83.4287 36.7669 86.1075 39.4347Z",
    fill: "url(#paint3_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1933 41.8279C59.9586 40.2897 55.9678 40.8531 53.2891 43.5209L37.6998 59.0468C39.2247 60.3271 40.8364 61.4525 42.5153 62.4217L51.5891 53.3848L63.1933 41.8279Z",
    fill: "url(#paint4_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2905 59.8625L48.1263 65.0057C50.2729 65.7644 52.4826 66.2999 54.716 66.6137L63.1947 58.1695C59.96 56.6312 55.9693 57.1946 53.2905 59.8625Z",
    fill: "url(#paint5_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7792 27.1791L27.615 22.0359C26.8532 24.1738 26.3155 26.3744 26.0004 28.5988L34.4791 37.043C36.0236 33.8215 35.4579 29.847 32.7792 27.1791Z",
    fill: "url(#paint6_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8876 37.0417C52.4321 33.8202 51.8664 29.8456 49.1876 27.1778L33.5983 11.6519C32.3129 13.1706 31.1829 14.7757 30.2097 16.4478L39.2835 25.4848L50.8876 37.0417Z",
    fill: "url(#paint7_linear_1219_434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1933 24.786L51.5891 13.2291L42.5153 4.19214C40.8378 5.16138 39.2247 6.28681 37.6998 7.56704L53.2891 23.093C55.9678 25.7608 59.9586 26.3242 63.1933 24.786Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1933 8.44422L54.716 0C52.4812 0.312387 50.2729 0.849303 48.1263 1.60796L53.2905 6.75119C55.9693 9.41903 59.96 9.98244 63.1947 8.44422H63.1933Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.999 37.0417L79.6031 25.4848L88.6769 16.4478C87.7038 14.7771 86.5737 13.1706 85.2883 11.6519L69.699 27.1778C67.0202 29.8456 66.4545 33.8202 67.999 37.0417Z",
    fill: "#E6007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1075 27.1791C83.4287 29.847 82.863 33.8215 84.4075 37.043L92.8862 28.5988C92.5726 26.3731 92.0334 24.1738 91.2717 22.0359L86.1075 27.1791Z",
    fill: "#E6007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.692 41.8279L67.2961 53.3848L76.3699 62.4217C78.0474 61.4525 79.6606 60.3271 81.1855 59.0468L65.5961 43.5209C62.9174 40.8531 58.9266 40.2897 55.692 41.8279Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8876 29.5723L39.2835 41.1292L30.2097 50.1661C31.1829 51.8368 32.3129 53.4434 33.5983 54.9621L49.1876 39.4362C51.8664 36.7683 52.4321 32.7938 50.8876 29.5723Z",
    fill: "#95C11F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.692 58.1695L64.1706 66.6137C66.4055 66.3013 68.6137 65.7644 70.7604 65.0057L65.5961 59.8625C62.9174 57.1946 58.9266 56.6312 55.692 58.1695Z",
    fill: "#F39200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4791 29.5723L26.0004 38.0165C26.3141 40.2422 26.8532 42.4415 27.615 44.5794L32.7792 39.4362C35.4579 36.7683 36.0236 32.7938 34.4791 29.5723Z",
    fill: "#95C11F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4433 36.1951C61.0449 36.1951 62.3433 34.902 62.3433 33.3069C62.3433 31.7118 61.0449 30.4187 59.4433 30.4187C57.8417 30.4187 56.5433 31.7118 56.5433 33.3069C56.5433 34.902 57.8417 36.1951 59.4433 36.1951Z",
    fill: "#95C11F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_434",
    x1: 55.692,
    y1: 14.9109,
    x2: 81.1855,
    y2: 14.9109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2D2E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2C3085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#254C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2060AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1D6CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D71B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1219_434",
    x1: 0.0000241904,
    y1: 4.64397,
    x2: 70.7604,
    y2: 4.64397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2D2E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2C3085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#254C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2060AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1D6CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D71B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1219_434",
    x1: 67.1504,
    y1: 42.2657,
    x2: 88.6769,
    y2: 42.2657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#662483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7E1F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#921B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9E195D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3195B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1219_434",
    x1: 83.5589,
    y1: 37.0751,
    x2: 92.8862,
    y2: 37.0751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#662483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7E1F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#921B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9E195D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3195B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1219_434",
    x1: 37.6998,
    y1: 51.703,
    x2: 63.1933,
    y2: 51.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E5491B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DC3D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CD291F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1219_434",
    x1: 48.1249,
    y1: 61.9697,
    x2: 0.140093,
    y2: 61.9697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E5491B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DC3D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CD291F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1219_434",
    x1: 26.0004,
    y1: 29.5388,
    x2: 35.3263,
    y2: 29.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#008835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#007C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#006833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#006633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1219_434",
    x1: 30.2097,
    y1: 24.3482,
    x2: 51.7348,
    y2: 24.3482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#008835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#007C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#006833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#006633"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 102,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentroZapopan);
export default __webpack_public_path__ + "static/media/centro-zapopan.497620d84f3c35c761c387d56fb54a2e.svg";
export { ForwardRef as ReactComponent };